import { useAppDispatch, useAppSelector } from 'hooks';
import React, { FC, useEffect } from 'react';
import { requestsActions } from 'utils/store/slice';
import { ECGCaptures, NotificationSetting } from './components';
import { DataStatus } from 'types/enums';
import styles from './styles.module.sass';
import { getUserAge } from 'utils';

export const EcgRequestData: FC = () => {
  const {
    analyzedEcgCaptures,
    analyzedPatient,
    analyzedRequest,
    analyzedAccount,
    analyzedEcgStatus,
    analyzedPatientStatus,
  } = useAppSelector((state) => state.requests);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(requestsActions.getAccountData(analyzedRequest.accountId));
  }, [analyzedRequest.accountId, dispatch]);

  useEffect(() => {
    if (analyzedAccount && analyzedPatientStatus === DataStatus.IDLE) {
      dispatch(requestsActions.getPatientsData(analyzedAccount.patientId));
    }
  }, [analyzedAccount, analyzedEcgCaptures, analyzedPatientStatus, dispatch]);

  useEffect(() => {
    if (analyzedPatient && analyzedEcgStatus === DataStatus.IDLE) {
      dispatch(requestsActions.getPatientEcgCaptures(analyzedPatient.id));
    }
  }, [analyzedPatient, analyzedEcgCaptures, dispatch, analyzedEcgStatus]);

  useEffect(() => {
    dispatch(requestsActions.getAccountNotificationSettings(analyzedRequest.accountId));
  }, [analyzedRequest.accountId, dispatch]);

  return (
    <div>
      <h4 className={styles.title}>
        Request for ecg data from patient: {analyzedAccount?.firstName} {analyzedAccount?.lastName}
      </h4>
      <NotificationSetting />
      <h4 className={styles.title}>Patient details:</h4>
      <div className={styles.patientDetails}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Age:</span>
          <span>{(analyzedPatient?.dateOfBirth && getUserAge(analyzedPatient.dateOfBirth)) || 'N/A'}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Gender:</span>
          <span>{analyzedPatient?.gender || 'N/A'}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>BMI:</span>
          <span>{analyzedPatient?.bmi || 'N/A'}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Race:</span>
          <span>{analyzedPatient?.race || 'N/A'}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Conditions:</span>
          <span>{analyzedPatient?.conditions?.join(', ') || 'None'}</span>
        </div>
      </div>
      <ECGCaptures />
    </div>
  );
};
